var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", { ref: "form", attrs: { slim: "" } }, [
    _c(
      "form",
      {
        staticClass: "form-horizontal",
        attrs: { role: "form", name: "vm.trustedFormSetting", novalidate: "" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "fieldset",
          [
            _c("Field", {
              attrs: {
                label: _vm.$t("API_TOKEN"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("API_TOKEN_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "apiKey",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.trustedFormSettingContext
                                                .apiKey,
                                            expression:
                                              "trustedFormSettingContext.apiKey"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.trustedFormSettingContext.apiKey
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.trustedFormSettingContext,
                                                "apiKey",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("Field", {
              attrs: {
                label: _vm.$t("CERT_ID_TAG_MAPPING"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t("CERT_ID_TAG_MAPPING_TT")
              },
              scopedSlots: _vm._u([
                {
                  key: "element",
                  fn: function() {
                    return [
                      _c("ValidationProvider", {
                        ref: "certificateTagName",
                        attrs: { rules: "required", slim: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ classes }) {
                              return [
                                _c("div", { class: classes }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-5 col-md-3" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.trustedFormSettingContext
                                                .certificateTagName,
                                            expression:
                                              "trustedFormSettingContext.certificateTagName"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.trustedFormSettingContext
                                              .certificateTagName
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.trustedFormSettingContext,
                                                "certificateTagName",
                                                $event.target.value
                                              )
                                            },
                                            _vm.onInput
                                          ],
                                          change: _vm.onChange
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    directives: [
                                      {
                                        name: "t",
                                        rawName: "v-t",
                                        value: "REQUIRED",
                                        expression: "'REQUIRED'"
                                      }
                                    ],
                                    staticClass:
                                      "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                  })
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }